// PII Data Requests — API layer over /api/pii-requests (see backend
// PiiDataRequestController). All responses are plain JSON maps (no envelope).
import { get, postMultipart, put } from '../../common/constants'

const BASE = 'pii-requests'

export const createPiiRequest = (file, reason) => {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('reason', reason)
  return postMultipart(BASE, fd)
}

export const fetchMyRequests = ({ status, fromDate, toDate, page, size }) =>
  get(`${BASE}/my`, {
    ...(status ? { status } : {}),
    ...(fromDate ? { fromDate } : {}),
    ...(toDate ? { toDate } : {}),
    page,
    size,
  })

export const fetchPendingApprovals = ({ page, size }) => get(`${BASE}/pending-approvals`, { page, size })

export const fetchDetail = (requestId) => get(`${BASE}/${requestId}`)

export const approveRequest = (requestId, level, remark) =>
  put(`${BASE}/${requestId}/approve`, { level, remark })

export const rejectRequest = (requestId, level, remark) =>
  put(`${BASE}/${requestId}/reject`, { level, remark })

export const retryGeneration = (requestId) => put(`${BASE}/${requestId}/retry`, {})

export const fetchDownloadUrl = (requestId) => get(`${BASE}/${requestId}/download`)

export const fetchInputFileUrl = (requestId) => get(`${BASE}/${requestId}/input-file`)

/** Uniform axios-error → user message (backend puts the reason in `message`/`exception`). */
export const extractPiiError = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.exception || err?.message || fallback
